import {OnFailure, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import {PhoneValidationResult} from "../../../model/validation/PhoneValidationResult";

/**
 * Validate phone number
 * @param {string} phoneNumber
 * @param {OnSuccessData<PhoneValidationResult>} onSuccess
 * @param {OnFailure} onFailure
 * @returns {() => void}
 */
export function validatePhone(phoneNumber: string, onSuccess: OnSuccessData<PhoneValidationResult>, onFailure: OnFailure) {
	return function() {
		api.instance.validationApi.validatePhone(phoneNumber).then(validationResult => {
			onSuccess(validationResult);
		}).catch(onFailure);
	};
}
